import { useNavigate } from 'react-router-dom';

import useStateHandler from '@/hooks/useStateHandler';
import ArtworkImage from '@/shared-components/cards/components/ArtworkImage';
import UserProfileImage from '@/shared-components/cards/components/UserProfileImage';
import Text from '@/shared-components/text/components/Text';
import TextHandler from '@/shared-components/text/components/TextHandler';
import Utils from '@/utils';
import { hasRenderableThought } from '@/utils/activityContent';
import { resolveFollowState } from '@/utils/followState';

import './styles/CommunityThoughtCard.css';

export default function CommunityThoughtCard({ data, showDate = true }) {
  const navigate = useNavigate();
  const { cacheHandler } = useStateHandler();
  if (!hasRenderableThought(data)) {
    return null;
  }
  const isFollowing = resolveFollowState({
    cacheHandler,
    userId: data.thought_creator?._id,
    imFollowing: data.thought_creator?.im_following,
  });

  return (
    <>
      <div
        className={`community-thought-card__container ${isFollowing ? 'following' : ''}`}
        onClick={() =>
          navigate(`/artwork/${data.thought_artwork.slug}?thought=${data._id}`, {
            state: {
              from: true,
              artworkViewSource: {
                type: 'community',
                label: '',
              },
            },
          })
        }
      >
        <div className="community-thought-card__header">
          <UserProfileImage
            image={data.thought_creator.user_image?.image_id}
            typeOfProfile={data.thought_creator.user_type}
            className="community-thought-card__user-image"
            onClick={(e) => {
              e.stopPropagation();
              navigate(`/user/${data.thought_creator.user_username}`);
            }}
          />

          <div className="community-thought-card__header-text">
            <Text
              className="community-thought-card__username"
              paragraph
              onClick={(e) => {
                e.stopPropagation();
                navigate(`/user/${data.thought_creator.user_username}`);
              }}>
              {data.thought_creator.user_username}
            </Text>
            <Text className="community-thought-card__small-text" extraSmall paragraph>
              added a thought on{' '}

              <span className="community-thought-card__artwork-title">
                {data.thought_artwork.artwork_about.artwork_title}
              </span>
            </Text>

          </div>

          {showDate && (
            <Text className="community-thought-card__timestamp" extraSmall paragraph>
              {Utils.elapsedTime(new Date(data.createdAt).getTime())}
            </Text>
          )}  
        </div>
        <TextHandler
          moreControlClick={() => {}}
          className="community-thought-card__thought-text-container"
          maxLinesWhenCollapsed={5}
          maxCharactersWhenCollapsed={400}
          controlsClassName="community-thought-card__thought-text-controls"
          text={data.thought_message} />

        <ArtworkImage
          image={data.thought_artwork.artwork_media.artwork_main_picture.image_id}
          imageClassName="community-thought-card__thought-image"
          imageTemplateClassName="community-thought-card__thought-image"
          onClick={(e) => {
            e.stopPropagation();
            navigate(`/artwork/${data.thought_artwork.slug}`, {
              state: {
                from: true,
                artworkViewSource: {
                  type: 'community',
                  label: '',
                },
              }
            });
          }}
          forceSmaller={300}
        />
      </div>
    </>
  );
}
